import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { ReservationCancellationReason } from './reservation-cancellation-reason.model';
import { ReservationCancellationReasonPopupService } from './reservation-cancellation-reason-popup.service';
import { ReservationCancellationReasonService } from './reservation-cancellation-reason.service';

@Component({
    selector: 'jhi-reservation-cancellation-reason-delete-dialog',
    templateUrl: './reservation-cancellation-reason-delete-dialog.component.html'
})
export class ReservationCancellationReasonDeleteDialogComponent {

    reservationCancellationReason: ReservationCancellationReason;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationCancellationReasonService: ReservationCancellationReasonService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['reservationCancellationReason']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.reservationCancellationReasonService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'reservationCancellationReasonListModification',
                content: 'Deleted an reservationCancellationReason'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-reservation-cancellation-reason-delete-popup',
    template: ''
})
export class ReservationCancellationReasonDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private reservationCancellationReasonPopupService: ReservationCancellationReasonPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.reservationCancellationReasonPopupService
                .open(ReservationCancellationReasonDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-cancellation-reason/reservation-cancellation-reason-delete-dialog.component.ts